var SENTRY_RELEASE;SENTRY_RELEASE={name: "BEAM", version: "0.1.0"};